/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';
import {
  PermissionManagerService,
  type PermissionUsageResponseDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

export interface PermissionUsagePayload {
  types?: string[];
  permissions?: string[];
}

const usePostPermissionUsage = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  PermissionUsageResponseDto | undefined,
  unknown,
  PermissionUsagePayload,
  unknown
> => {
  return useMutation(async (payload: PermissionUsagePayload) => {
    return await handleRequest(
      PermissionManagerService.postApiCustomerApiPermissionManagerUsage(
        payload.types,
        payload.permissions
      )
    );
  });
};

export default usePostPermissionUsage;
